import { ref } from 'vue'
import Api from '@/api'
import { cacheRailContent } from '@/helpers/cms-cache'
import { RailResponse } from '@/types/cms';


const loggingEnabled = process.env.NODE_ENV !== 'production';
const log = (msg: string) => { if (loggingEnabled) console.log(`[CMSRailManager] ${msg}`) }
type CMSRailLoadingState = 'loading' | 'error' | 'success'

const rails = ref<RailResponse[] | undefined>(undefined)
const state = ref<CMSRailLoadingState>('loading')

let pollTimeout: ReturnType<typeof setTimeout> | null = null
let isPolling = false

function startPolling() {
  if (isPolling) {
    log('Already polling, skipping')
    return
  }
  log('Polling started')
  isPolling = true
  refreshRails()
}

function scheduleNextPoll(seconds: number) {
  if (!isPolling) {
    log('Not scheduling next poll since polling is stopped')
    return
  }
  log(`Next poll in ${seconds}s`)
  if (pollTimeout !== null) {
    clearTimeout(pollTimeout)
  }
  pollTimeout = setTimeout(refreshRails, seconds * 1000)
}

async function refreshRails() {
  try {
    log('Polling...')
    const response = await Api.CMS.getHomeRails()
    rails.value = response.rails
    state.value = 'success'
    log(`Got ${response.rails.length} rails`)

    cacheRailContent(response.rails)

    scheduleNextPoll(response.pollIntervalSeconds > 0 ? response.pollIntervalSeconds : 10)
  } catch (error) {
    log(`Failed to fetch rails: ${error}`)
    if (rails.value === undefined) {
      state.value = 'error'
    }
    scheduleNextPoll(10)
  }
}

function stopPolling() {
  log('Polling stopped')
  isPolling = false
  if (pollTimeout !== null) {
    clearTimeout(pollTimeout)
    pollTimeout = null
  }
}

export const CMSRailManager = {
  rails,
  state,
  startPolling,
  refreshRails,
  stopPolling
}
